let configurations = {
    isDebug: false
};
export default configurations;